
const config = {
  apiEndpoint: "//api.shor.by/v1",
  scraperEndpoint: "//scraper.shor.by",
  lightningHost: "//shor.by",
  actionCableEndpoint: "wss://api.shor.by/cable",
  stripePK: "pk_live_VVAJvhQC3dkAA65OKv5K5Hzm",
  filestackKey: "ACu6zRr4STeUW5lt46U5Qz"
};

export default config;


// WEBPACK FOOTER //
// ./src/config/production.js